import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectorRef,  } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ProfewoOffer } from '@app/models/offerpack/ProfewoOffer';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-profweo-detail',
    templateUrl: './profweo-detail.component.html',
    styleUrls: ['./profweo-detail.component.scss'],
    standalone: false
})
export class ProfweoDetailComponent implements OnInit {
    @Input() datas: ProfewoOffer;
    @Output() sendReg: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;

    curentContent: number = 0;

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskMode = true;
        }
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAnmeldung() {
        this.sendReg.emit(true);
    }
}
